/* 
These functions make sure WordPress 
and HgConstruction play nice together.
*/

jQuery(document).ready(() => {

  // Adds Flex Video to YouTube and Vimeo Embeds
  jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').addClass('embed-responsive-item').wrap("<div class='embed-responsive embed-responsive-16by9'/>");

  const $mainNavbar = jQuery('.main-navbar');
  const $navbarToggler = jQuery('.main-navbar .navbar-toggler');
  const $navbarCollapse = jQuery('.main-navbar .navbar-collapse');

  $navbarToggler.click(() => {
    $mainNavbar.toggleClass('open');
    $navbarToggler.toggleClass('collapsed')
    $navbarCollapse.toggleClass('show');
  });

});
